import $ from 'jquery';
import { Ajaxinate } from 'ajaxinate';
import { init as initSwatch } from './swatch';
const showSwatches = ()=>{
    $('.CollItem').mouseenter(function() {
        const smpHandle = $(this).attr('smp-prod-handle');
        $('.CollItem-swatchesNo.hover[smp-prod-handle="' + smpHandle + '"]').fadeOut();
        $('.CollItem-swatchesColors.hover[smp-prod-handle="' + smpHandle + '"]').fadeIn();
    }).mouseleave(function() {
        const smpHandle = $(this).attr('smp-prod-handle');
        $('.CollItem-swatchesNo.hover[smp-prod-handle="' + smpHandle + '"]').fadeIn();
        $('.CollItem-swatchesColors.hover[smp-prod-handle="' + smpHandle + '"]').fadeOut();
    });
};
export const init = async function() {
    const tap = 'ontouchstart' in document.documentElement;
    document.addEventListener('DOMContentLoaded', function() {
        new Ajaxinate({
            callback: ()=>{
                showSwatches();
                initSwatch();
            }
        });
    });
    if (!tap) {
        showSwatches();
    }
};
